import { OptieStatus } from './optie-status.model';

export interface Optie {
  status: OptieStatus;
}
